/*
 * @Author: Alan
 * @Date: 2023-03-22 14:34:19
 * @LastEditors: Alan
 * @LastEditTime: 2023-03-28 11:44:16
 * @Description: 超过验证次数
 * @FilePath: \F1-M2-WEB-Code\components\OTP\ExceedVerify.js
 */
import React from "react";
import { Row, Col, Button, Modal } from "antd";

function ExceedVerify({
    offset,
    exceedVisible,
    times,
    headTitle,
    otpParam,
    onCancel,
    Description,
    btnInfo,
}) {
    // 彈窗，次數，標題，判斷OTP種類

    return (
        <Modal
            style={offset ? { left: offset.left, top: offset.top } : {}}
            title={headTitle}
            className="modal-pubilc exceed-modal"
            visible={exceedVisible}
            closable={false}
            onCancel={onCancel}
            centered={true}
            width={400}
            footer={null}
            zIndex={1500}
            keyboard={false}
            maskClosable={false}
        >
            <Row>
                <Col span={24}>
                    <img
                        className="otp-warn"
                        src="/th/img/icons/icon-warn.svg"
                        alt="icon-warn"
                    />
                    <h3 className="otp-modal-title">
                        คุณทำการยืนยันข้อมูลเกินที่กำหนด
                    </h3>
                    {/* 您已超过{times}次尝试 */}
                    <div className="otp-cs-tip-exceed">
                        คุณทำการยืนยันข้อมูลเกิน 5 ครั้ง กรุณาติดต่อเจ้าหน้าที่
                        ฝ่ายบริการ เพื่อช่วยเหลือการยืนยันข้อมูลหรือลองใหม่
                        อีกครั้งหลังจาก 24 ชั่วโมง
                        {/* 请24小时之后再试或联系我们的在线客服进行验证。 */}
                    </div>
                </Col>
            </Row>
            <div className={`exceed-btn-wrap`}>
                <Button
                    onClick={() => {
                        onCancel();
                    }}
                    type="primary"
                    ghost
                    block
                    size="large"
                >
                    ปิด
                </Button>
                <Button
                    onClick={() => {
                        global.PopUpLiveChat();
                    }}
                    type="primary"
                    block
                    size="large"
                >
                    เจ้าหน้าที่ฝ่ายบริการ{/* 联系在线客服 */}
                </Button>
            </div>
        </Modal>
    );
}

export default ExceedVerify;
